<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar :title="$t('menu.subcontractor_approvals')" class="mb-2"/>
    <keep-alive>
      <application-search
        v-if="!editMode"
        @search="fetchApplications"
      />
    </keep-alive>
    <div
      v-if="!editMode"
      class="col-sm-12 mt-2"
    >
      <div
        class="data-list-item add"
        @click.stop="addApplication"
      >
        <div class="item-img-cont add-title">
          <i class="fa fa-plus" />
        </div>
        <div class="item-text-cont">
          <span class="item-title-add">{{ $t('common.add_new') }}</span>
          <font-awesome-icon
            icon="file-contract"
            class="card-body-icon"
          />
        </div>
      </div>
    </div>
    <keep-alive>
      <application-list
        v-if="!editMode"
        class="mt-2"
        :applications="applications"
        @edit="editApplication"
      />
    </keep-alive>
        <base-modal v-if="editMode" size="lg" hide-footer hide-header @close="showApplicationsList">
            <application-editor
                :application="application"
                @update="update"
                @close="showApplicationsList"
            />
        </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import ApplicationSearch from "@/components/subcontractors/ApplicationSearch";
import ApplicationList from "@/components/subcontractors/ApplicationList";
import ApplicationEditor from "@/components/subcontractors/ApplicationEditor";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'SubcontractorApplications',
    components: {
        BaseModal,
        Navbar,
        ApplicationEditor,
        ApplicationList,
        ApplicationSearch
    },
    mixins: [timeUtils, restApi],
    data: function () {
        return {
            loading: 0,
            applications: [],
            editMode: false,
            application: null
        }
    },
    methods: {
        fetchApplications: function (params) {
            this.loading++
            this.applications = []
            if (!params) {
                params = {}
            }
            this.lastSearchParams = params
            this.restFetchParams(this.subcontractorApplicationUrl, this.lastSearchParams, this.fetchSuccess, this.fetchFail)
        },
        fetchSuccess: function (response) {
            this.applications = response.data
            this.loading--
        },
        fetchFail: function () {
            this.loading--
        },
        update: function () {
            this.showApplicationsList()
            this.fetchApplications(this.lastSearchParams)
        },
        editApplication: function (application) {
            this.application = application
            this.editMode = true
        },
        showApplicationsList: function () {
            this.editMode = false
            this.application = null
        },
        addApplication() {
            this.application = {
                id: null,
                subcontractor_name: null,
                subcontractor_business_id: null,
                customer: null,
                time_from: null,
                time_to: null
            }
            this.editMode = true
        }
    }
}
</script>
